let timer = null;
export default {
  state: {
    sceneType: 'full', // full , 3d
    show: false,
    rate: '0'
  },
  getters: {
    loading: state => state
  },
  mutations: {
    setLoadStart (state, { sceneType = 'full' }) {
      if (state.sceneType === '3d') { // 3d 优先级最高
        return;
      }
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
      state.sceneType = sceneType;
      state.show = true;
      state.rate = 1;
      timer = setInterval(function () {
        state.rate = state.rate + 1;
        if (state.rate === 99) {
          window.clearInterval(timer);
          timer = null;
        }
      }, 30);
    },
    setLoadComplete (state, { sceneType = 'full', callBack }) {
      if (sceneType === state.sceneType) {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
        state.rate = 100;
        setTimeout(function () {
          typeof callBack === 'function' && callBack();
          state.show = false;
          state.rate = 0;
          state.sceneType = '';
        }, 10);
      }
    }
  },
  actions: {},
  namespaced: true
};
